import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import { sendContact } from "../services/api";

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b">
      <button
        onClick={() => setOpen(!open)}
        className={`w-full text-left flex justify-between items-center py-3 ${open ? 'brand-orange-text font-semibold' : 'text-gray-800'}`}
        aria-expanded={open}
      >
        <span className="truncate">{q}</span>
        <span className="text-gray-500 ml-4">{open ? '-' : '+'}</span>
      </button>

      <div
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: open ? '240px' : '0px' }}
        aria-hidden={!open}
      >
        <div className="pt-3 pb-4 text-gray-600">
          {a}
        </div>
      </div>
    </div>
  );
}

function Contact() {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', address: '', message: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const res = await sendContact(form);
      if (res.data && res.data.success) {
        setStatus({ type: 'success', message: res.data.message || 'Your query has been sent to administrator, we will get back to you soon.' });
        setForm({ firstName: '', lastName: '', email: '', phone: '', address: '', message: '' });
      } else {
        setStatus({ type: 'error', message: res.data.message || 'Failed to send message.' });
      }
    } catch (err) {
      setStatus({ type: 'error', message: 'Failed to send message.' });
    }
    setLoading(false);
  };

  return (
    <div className="bg-white min-h-screen">
      <Header />

      <PageBanner
        title="Contact Us"
        subtitle="Questions? We're here to help — reach out to our team."
        image="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1920&q=80"
      />

      <main className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-10">

          {/* Left - FAQs */}
          <div>
            <h3 className="text-2xl font-semibold mb-6">Frequently Asked Questions</h3>
            <div className="bg-white rounded-lg shadow divide-y p-4">
              <FAQItem q="How do you determine 'nearby'?" a="We use your device's geolocation (when permitted) to calculate distance to listings and rank them accordingly." />
              <FAQItem q="Can I request a partnership?" a="Yes — use the contact form and include details about your property or service. We'll review and reply." />
              <FAQItem q="How accurate are distances?" a="Distances are calculated using straight-line Haversine formula and shown in kilometers." />
            </div>
          </div>

          {/* Right - Contact Form */}
          <div>
            <h3 className="text-2xl font-semibold mb-6">Send us a message</h3>

            <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <input name="firstName" value={form.firstName} onChange={handleChange} placeholder="First Name" className="w-full px-4 py-2 border rounded" required />
                <input name="lastName" value={form.lastName} onChange={handleChange} placeholder="Last Name" className="w-full px-4 py-2 border rounded" required />
              </div>

              <input name="email" value={form.email} onChange={handleChange} placeholder="Email" type="email" className="w-full px-4 py-2 border rounded" required />
              <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone no." className="w-full px-4 py-2 border rounded" />
              <input name="address" value={form.address} onChange={handleChange} placeholder="Address" className="w-full px-4 py-2 border rounded" />

              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Message" rows={5} className="w-full px-4 py-2 border rounded" required />

              {status && (
                <div className={`p-3 rounded ${status.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                  {status.message}
                </div>
              )}

              <div className="flex justify-end">
                <button type="submit" disabled={loading} className="brand-orange-bg text-white px-6 py-2 rounded">
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </div>
            </form>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
